<template>
  <div class="d-flex wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>e-Sign</h2>
    </div>
    <span class="tooltip-wrapper pointer" style="float:right">
    <i 
      class="fa fa-times cursor-pointer" 
      @click="closesign()">
    </i>
    <span class="custom-tooltip closetooltipposition">Close</span>
  </span>
  </div>
  <div class="wrapper wrapper-content animated fadeInRight">
  <!-- Preparing / fetching the signing URL -->
  <div v-if="isSigningUrlFetching" class="iframe-loader-container">
    <div class="iframe-loader">
      <img src="../../assets/img/loading.gif" width="24" alt="Loading..." />
      <div class="mt-2 small-text">Preparing signing session…</div>
    </div>
  </div>


  <!-- Iframe + loader while the document loads -->
  <div v-else class="iframe-container">
    <div v-if="isIframeLoading" class="iframe-loader-overlay">
      <div class="iframe-loader">
        <img src="../../assets/img/loading.gif" width="24" alt="Loading..." />
        <div class="mt-2 small-text">Loading document…</div>
      </div>
    </div>

    <iframe
      v-if="iframeurl"
      ref="dsFrame"
      :src="iframeurl"
      width="100%"
      height="650"
      frameborder="0"
      @load="onIframeLoad"
    />
  </div>
</div>

</template>

<script src="./signfrompopup.js"></script>
<style scoped>
.badge-grn {
  background-color: #1ab394;
  color: #ffffff;
}

.badge-warning {
  background-color: #f8ac59;
  color: #ffffff;
}

.badge-danger {
  background-color: #ed5565;
  color: #ffffff;
}

.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
  max-width: 200px;
}

.btn-green-new {
  color: #fff;
  background-color: #1ab394;
  /* border-color: #1ab394; */
  border: none;
}

.btn-danger-new {
  color: #fff;
  background-color: #ed5565;
  border: none;
}

.text-green {
  color: #1ab394 !important;
}

.rotate {
  transform: rotate(180deg);
  transition: all 0.3s ease;
}

.height-scroll {
  height: 250px;
  overflow-y: auto;
}

.small-text {
  font-size: 80%;
  font-weight: 400;
  color: #6b6b6b;
}
</style>
